import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserService } from "../../services/user.service";

@Component({
  selector: "app-forgotten-password",
  templateUrl: "./forgotten-password.component.html",
  styleUrls: ["./forgotten-password.component.scss"],
})
export class ForgottenPasswordComponent implements OnInit {
  emailAddressToReset: string = "";
  requestResetSuccess: boolean = false;
  requestResetFail: boolean = false;
  requestResetFailNoUserFound: boolean = false;
  onDestroy$ = new Subject();

  constructor(private userService: UserService) {}

  ngOnInit() {}

  /***
   * Request a password reset
   */
  requestResetPassword() {
    // Reset success/fail flags
    this.requestResetSuccess = false;
    this.requestResetFail = false;
    this.requestResetFailNoUserFound = false;
    this.userService
      .requestResetPasswordUserAccount(this.emailAddressToReset)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.requestResetSuccess = true;
          this.requestResetFail = false;
        },
        (error) => {
          this.requestResetSuccess = false;
          // User error - user not found for email address
          if (error.status === 404) {
            this.requestResetFailNoUserFound = true;
          } else {
            this.requestResetFail = true;
          }
        }
      );
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
